<script>
import ViewSensors from "@/modules/common/views/ViewSensors";
import * as settings from "../settings";

export default {
    name: "Sensors",
    functional: true,
    render(createElement) {
        return createElement(ViewSensors, {
            props: {
                settings: {
                    ...settings
                }
            }
        });
    }
};
</script>
